import React from "react"
import ReactApexChart from "react-apexcharts"
import getChartColorsArray from "components/Common/ChartsDynamicColor"
import { useTranslation } from "react-i18next"

export const CategoryDistribution = () => {
  const { i18n } = useTranslation()
  const dountApexChartColors = getChartColorsArray(
    '["--bs-info", "--bs-primary", "--bs-secondary", "--bs-warning", "--bs-success"]'
  )

  const series = [32.0, 25.6, 23.8, 9.9, 8.7]
  const options = {
    labels: [
      i18n.t("dashboard_copon"),
      i18n.t("dashboard_bottle500Ml"),
      i18n.t("dashboard_bottel20"),
      i18n.t("dashboard_dispenser"),
      i18n.t("dashboard_other"),
    ],
    colors: dountApexChartColors,
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      verticalAlign: "middle",
      floating: false,
      fontSize: "14px",
      offsetX: 0,
      offsetY: -10,
      formatter: function (val: string, opts: any) {
        const percent = series[opts.seriesIndex]
        return `${val} <br/> ${percent.toFixed(1)} %`
      },
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            height: 240,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  }
  return (
    <div className="d-flex flex-column align-items-start gap-4">
      <h4 className="font-size-16 text-capitalize fw-semibold">
        {i18n.t("dashboard_categoryDistribution")}
      </h4>
      <style>
        {`
        .apexcharts-legend {
            justify-content: start !important;
            padding-top: 10px !important;
        }
        .apexcharts-legend-series {
            display: flex !important;
            align-items: baseline !important;
            min-width: 80px !important;
        }
        `}
      </style>
      <div className="align-self-center">
        <ReactApexChart
          options={options as any}
          series={series}
          type="donut"
          height="420"
        />
      </div>
    </div>
  )
}
